import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      if (res.user?.email_verified === false) {
        navigate("/verify-email");
        return;
      }
      const hasPending = !!sessionStorage.getItem("inlight_current_prayer");
      navigate(hasPending ? "/prayer" : "/builder");
    } else setError(res.error);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--sanctuary-bg)" }}>
      <Header />
      <div className="sanctuary-glow absolute inset-x-0 top-16 h-[420px] -z-0 pointer-events-none" />
      <div className="relative max-w-md mx-auto px-6 pt-20 md:pt-28">
        <h1
          className="font-serif-display text-4xl md:text-5xl mb-3 tracking-tight"
          style={{ color: "var(--sanctuary-ink)" }}
          data-testid="login-title"
        >
          Welcome back
        </h1>
        <p className="mb-12 text-base" style={{ color: "var(--sanctuary-ink-soft)" }}>
          Step quietly into your sanctuary.
        </p>

        <form onSubmit={submit} className="space-y-10">
          <div>
            <label className="block text-xs tracking-widest uppercase mb-3" style={{ color: "var(--sanctuary-ink-muted)" }}>
              Email
            </label>
            <input
              data-testid="login-email-input"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-line"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="block text-xs tracking-widest uppercase mb-3" style={{ color: "var(--sanctuary-ink-muted)" }}>
              Password
            </label>
            <input
              data-testid="login-password-input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-line"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p data-testid="login-error" className="text-sm" style={{ color: "var(--sanctuary-alert)" }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit-button"
            className="w-full px-8 py-4 rounded-full btn-primary text-base disabled:opacity-60"
          >
            {busy ? "Entering…" : "Sign in"}
          </button>
        </form>

        <p className="mt-10 text-sm" style={{ color: "var(--sanctuary-ink-soft)" }}>
          New here?{" "}
          <Link to="/register" data-testid="login-to-register-link" className="underline" style={{ color: "var(--sanctuary-accent)" }}>
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
